module.exports = __webpack_public_path__ + "img/lightBrown_attached.7f242864.svg";